import React, {Component} from 'react';
import Dashboard from './Dashboard';
import {GET_DASHBOARD} from '../queries';
import { Query } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { removeTrailingSlashes } from '../utils';
import { Container } from 'react-bootstrap';
const nanoid = require('nanoid');

class PublicHome extends Component<any, any> {
  refreshDashboardCallback:any;

  constructor(props: any) {
    super(props);
    this.refreshDashboard = this.refreshDashboard.bind(this);

    this.state = {
      publicAuthenticating: true
    };
  }

  private refreshIntervalId: any;

  componentDidMount() {
    this.refreshPublicToken();

    this.refreshIntervalId = setInterval(
      () => {
        this.refreshPublicToken();
      },
      5*60*1000); // every 5 minutes
  }

  componentWillUnmount() {
    if (this.refreshIntervalId) {
      clearInterval(this.refreshIntervalId);
    }
  }
   
  async refreshDashboard() {
    return this.refreshDashboardCallback();
  }

  assignRefetch(func:Function) {
    this.refreshDashboardCallback = func;
  }

  async refreshPublicToken() {
    const { auth } = this.props;

    // If the user is already logged in, don't nuke their token
    if (!auth.isAuthenticated()) {
      await auth.refreshPublicChatbotAuth();
    }

    this.setState({publicAuthenticating: false});
  } 

  renderError(dashId: string) {
    console.log(`unable to load public dashboard: ${dashId}`);

    return<Container fluid className="dashboard_container">
      <div className="text-center">Error loading the requested dashboard.</div>
    </Container>; 
  }

  render() {
    const { match, currentUser } = this.props;
    const { publicAuthenticating } = this.state;

    const params = match.params;

    if (publicAuthenticating) {
      return (<div>Loading...</div>);
    } else {
      return (
        <div className="App">
          <Query<any, any>
            query={GET_DASHBOARD}
            fetchPolicy="no-cache"
            notifyOnNetworkStatusChange={true}
            variables={{id: params.id}}
          >{
            ({data, loading, error, refetch, networkStatus}) => {
              if (networkStatus === 4) return <div>Refetching!</div>;
    
              if (loading) {
                return (<div>Loading...</div>);
              }
  
              if (!data || error) {
                console.error(error);
                return (this.renderError(params.id));
              }
  
              const { syncarto_app_dashboard_by_pk } = data;
    
              // an authenticated user may have access to this dashboard
              // even when it is not public. do not allow access through
              // the public route.
              if (!syncarto_app_dashboard_by_pk || !syncarto_app_dashboard_by_pk.is_public) {
                return (this.renderError(params.id));          
              }

              this.assignRefetch(refetch);
              
              // combine the dashboard id with the session id
              const sessionToken = params.session ?  params.session : nanoid(8);
              const session = { id: (syncarto_app_dashboard_by_pk.id + '-' + sessionToken) };
    
              if (!params.session) {
                let path = removeTrailingSlashes(this.props.location.pathname);
                window.history.replaceState(null, "", `${path}/${sessionToken}`);
              }
  
              return (
                <Dashboard 
                  currentUser={currentUser} 
                  dashboardData={syncarto_app_dashboard_by_pk} 
                  session={session} 
                  dashboardId={syncarto_app_dashboard_by_pk.id}
                  refetchDashboard={this.refreshDashboard} 
                  isPublic={true} 
                  userOrgs={this.props.userOrgs} 
                  refreshAllCredentials={this.props.refreshAllCredentials} />
              );
            }
            }
          </Query>
          </div>
      );
    }
  }
}

export default withRouter(PublicHome);
